// @flow
import type { StoreResourceDef } from 'app/core/types'
import api from 'app/core/api/api.js'
import type { DynamicApprovalsActions } from 'app/core/types/StoreResourcesCustomActions'
import { transformResults } from './utils/transformResults'
import { autocomplete } from './autocomplete.js'

export const dynamicApprovals: StoreResourceDef<DynamicApprovalsActions<>> = {
  resourceType: 'dynamicApprovals',
  actions: (actionsCreators: Object) => ({
    fetchByProject: (projectId: string, config: Object = {}) => {
      const { params = {} } = config
      return {
        type: 'read',
        requestKey: config?.requestKey,
        request: () =>
          api.projects.dynamicApprovals({ id: projectId, ...params.queries }).then(transformResults(config)),
      }
    },
    search: autocomplete('dynamicApproval'),
  }),
}
